import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/legal-and-compliance/page-client.tsx");
